<template>
    <button :type="type" @click="this.$emit('click')" :class="`btn ${className}`" :disabled="disabled">
        {{ label }}
    </button>
</template>

<script>
    export default {
        props: {
            label: String,
            type: String,
            className: String,
            disabled: Boolean,
        },
        emits: ['click'],
    }
</script>

<style lang="scss" scoped>
.btn {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    margin: 0;
    width: 240px;
    height: 45px;
    font-size: 1rem;
    font-weight: 700;
    transition: 0.5s;
    cursor: pointer;
}

.confirm {                                      // красная кнопка для утверждения действия
    color: white;
    border: 1px solid #ff144f;
    background-color: #ff144f;

    &:hover {
        color: #ff144f;
        background-color: white;
    }

    &:active {
        color: white;
        background-color: #b02a37;
        border-color: #b02a37;
    }

    &:disabled {
        background-color: #b02a37;
        border-color: #b02a37;
        opacity: 0.65;
    }
}

.infomation {                                      // серая кнопка для какой-то побочной инфы
    color: #2c2d2e;
    border: 1px solid #e8e8e8;
    background-color: white;

    &:hover {
        color: white;
        background-color: #ff144f;
        border-color: #ff144f;
    }

    &:active {
        color: white;
        background-color: #b02a37;
        border-color: #b02a37;
    }

    &:disabled {
        opacity: 0.65;
    }
}

.select {                                      // красная кнопка для утверждения действия
    color: #00509f;
    border: 1px solid #00509f;
    background-color: #f2f3f5;

    &:hover {
        color: white;
        background-color: #0b5ed7;
        border-color: #0b5ed7;
    }

    &:active {
        background-color: #0d6efd;
        border-color: #0d6efd;
    }

    &:disabled {
        opacity: 0.65;
    }

    &.active {
        color: white;
        background-color: #00509f;
    }
}
</style>